import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { GiFinSimulacaoFinanciadoraModel } from "../../../dominio/gi-fin-simulacao-financiadora-model";
import { GiFinMotivoNegativaModel } from "../../../dominio/gi-fin-motivo-negativa-model";
import { FinSimulacaoService, JustificativaFinanciadoraRequest } from "../../../services/fin-simulacao.service";
import { NotificacaoService } from "../../../services/notificacao.service";
import { CarregandoService } from "../../../services/carregando.service";
import { ArquivoService } from "../../../services/arquivo.service";
import { UtilitarioService } from "../../../services/utilitario.service";
import { TipoArquivo } from "../../../models/enum";
import { MotivoNegativaConfigService, opcoesMotivoNegativa } from "../../services/motivo-negativa-config.service";

export interface JustificativaNegativaSimulacaoResult {
  justificativa: string;
  financiadoras: JustificativaFinanciadoraRequest[];
}

interface FinanciadoraNegativa {
  vinculo: GiFinSimulacaoFinanciadoraModel;
  exibir: boolean;
  idMotivoNegativa: number | null;
  motivos: GiFinMotivoNegativaModel[];
}

@Component({
  selector: "app-justificativa-negativa-simulacao-modal",
  templateUrl: "./justificativa-negativa-simulacao-modal.component.html",
  styleUrls: ["./justificativa-negativa-simulacao-modal.component.scss"],
})
export class JustificativaNegativaSimulacaoModalComponent implements OnInit {
  readonly tamanhoMaximo = 1000;
  config: PerfectScrollbarConfigInterface = {};

  idTarefa: number;
  justificativa = "";
  financiadoras: FinanciadoraNegativa[] = [];

  constructor(
    private dialogRef: MatDialogRef<JustificativaNegativaSimulacaoModalComponent, JustificativaNegativaSimulacaoResult>,
    @Inject(MAT_DIALOG_DATA) public data: { idTarefa: number },
    private finSimulacaoService: FinSimulacaoService,
    private motivoNegativaService: MotivoNegativaConfigService,
    private notificacaoService: NotificacaoService,
    private carregandoService: CarregandoService,
    private arquivoService: ArquivoService,
    private utilitarioService: UtilitarioService,
  ) {
    this.idTarefa = data.idTarefa;
  }

  ngOnInit() {
    this.buscarFinanciadoras();
  }

  buscarFinanciadoras() {
    this.carregandoService.mostra("buscarFinanciadorasNegativa");

    forkJoin([
      this.finSimulacaoService.buscarFinanciadorasPorTarefa(this.idTarefa),
      this.motivoNegativaService.buscarAtivos(),
    ]).subscribe(
      ([financiadoras, motivos]) => {
        const ativos = motivos.results || [];

        this.financiadoras = (financiadoras.results || []).map((vinculo) => ({
          vinculo,
          exibir: !!vinculo.visivel,
          idMotivoNegativa: vinculo.idMotivoNegativa || null,
          motivos: opcoesMotivoNegativa(ativos, vinculo),
        }));

        this.financiadoras.forEach((f) => {
          this.buscarSumario(f.vinculo);
          this.buscarLogo(f.vinculo);
        });

        this.carregandoService.esconde("buscarFinanciadorasNegativa");
      },
      (erro) => {
        this.carregandoService.esconde("buscarFinanciadorasNegativa");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarSumario(vinculo: GiFinSimulacaoFinanciadoraModel) {
    this.finSimulacaoService.buscaSumarioFinanciadoraCelulaCredito(this.idTarefa, vinculo.id).subscribe(
      (data) => {
        vinculo.sumario = data.result;
      },
      () => { }
    );
  }

  buscarLogo(vinculo: GiFinSimulacaoFinanciadoraModel) {
    const financiadora = vinculo.financiadora;

    if (!financiadora) {
      return;
    }

    financiadora.imagem$ = this.arquivoService
      .baixarArquivo(financiadora.id, TipoArquivo.FinanciadoraImagem)
      .pipe(map((m) => this.utilitarioService.toBase64ComInicio(m)))
      .toPromise();

    financiadora.imagem$
      .then(() => financiadora.buscouImagem = true)
      .catch(() => financiadora.semImagem = true);
  }

  confirmar() {
    if (!this.justificativa || !this.justificativa.trim()) {
      return;
    }

    this.dialogRef.close({
      justificativa: this.justificativa.trim(),
      financiadoras: this.financiadoras.map((f) => ({
        idVinculo: f.vinculo.id,
        exibir: f.exibir,
        idMotivoNegativa: f.exibir ? f.idMotivoNegativa : null,
      })),
    });
  }

  fechar() {
    this.dialogRef.close();
  }
}
